class GeroClearSearchanise {
  constructor() {
    this.CLOSE_SELECTOR = ".wt-header__search__close";
    this.INPUT_SELECTOR = ".wt-header__search__form input[name='q']";
    this.closeLabel = document.querySelector(this.CLOSE_SELECTOR).getAttribute("aria-label");
    this.clearLabel = document.querySelector(".wt-header__search__clear-button").getAttribute("aria-label");
  }

  clear(input) {
    input.value = "";
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.focus();
  }

  onClick(event) {
    const close = event.target.closest(this.CLOSE_SELECTOR);
    if (null == close) {
      return;
    }

    const input = close.closest(".wt-header__search__form").querySelector(this.INPUT_SELECTOR);
    if (null == input || 0 == input.value.length) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    this.clear(input);
  }

  onInput(input) {
    const closeButton = input.closest(".wt-header__search__form").querySelector(this.CLOSE_SELECTOR);
    closeButton.setAttribute("aria-label", 0 == input.value.length ? this.closeLabel : this.clearLabel);
  }

  init() {
    document.addEventListener("click", (event) => this.onClick(event), true);
    document.querySelectorAll(this.INPUT_SELECTOR).forEach((input) => {
      input.addEventListener("input", () => this.onInput(input));
    });
  }
}

new GeroClearSearchanise().init();
